import moment from 'moment-timezone';

/** Pasar a false para mostrar el día de la semana junto a la fecha incidente en todos los tenants. */
const hideBlumarStuffForOthers = true;
export const BLUMAR_SSO_TENANT_ID = '62a8b6dd2323505723b7e92b';

const WEEKDAY_ES = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'] as const;

export function isBlumarSsoTenant(tenant?: any): boolean {
  if (!hideBlumarStuffForOthers) return true;
  const id = tenant?._id ?? tenant?.id ?? tenant;
  return String(id || '') === BLUMAR_SSO_TENANT_ID;
}

export function isIncidentDateKeyPointer(keyPointer?: unknown): boolean {
  const base = String(keyPointer || '').replace(/^incident_/, '');
  return base === 'incidentDate';
}

export function spanishWeekdayFromDate(value: unknown): string | null {
  if (value == null || value === '') return null;
  const parsed = moment(value);
  if (!parsed.isValid()) return null;
  return WEEKDAY_ES[parsed.day()] || null;
}

function withSpanishWeekday(formatted: string, weekday: string | undefined): string {
  return weekday ? `${weekday} ${formatted}` : formatted;
}

/** Formato moment/MUI con el día como literal: `[Jueves] DD-MM-YYYY HH:mm`. */
export function pickerFormatWithSpanishWeekday(dateFormat: string, weekday: string | null | undefined): string | undefined {
  if (!weekday) return undefined;
  return `[${weekday}] ${dateFormat}`;
}

export function formatDateWithSpanishWeekday(value: unknown, dateFormat: string): string {
  if (value == null || value === '') return '';
  const parsed = moment(value);
  if (!parsed.isValid()) return String(value);
  const formatted = parsed.format(dateFormat);
  return withSpanishWeekday(formatted, WEEKDAY_ES[parsed.day()]);
}

export function appendSpanishWeekdayIfBlumar(value: unknown, dateFormat: string, tenant?: any): string {
  if (value == null || value === '') return '';
  const parsed = moment(value);
  if (!parsed.isValid()) return String(value);
  const formatted = parsed.format(dateFormat);
  if (!isBlumarSsoTenant(tenant)) return formatted;
  return withSpanishWeekday(formatted, WEEKDAY_ES[parsed.day()]);
}

export function formatIncidentDateAnswerIfBlumar(
  value: unknown,
  dateFormat: string,
  keyPointer: unknown,
  tenant?: any,
): string {
  if (value == null || value === '') return '';
  const parsed = moment(value);
  if (!parsed.isValid()) return String(value);
  const formatted = parsed.format(dateFormat);
  if (!isBlumarSsoTenant(tenant) || !isIncidentDateKeyPointer(keyPointer)) return formatted;
  return withSpanishWeekday(formatted, WEEKDAY_ES[parsed.day()]);
}
